import React from 'react'

export default function Pagnotfound() {
  return (
    <div style={{width:'100%',height:"100vh",display:"flex",justifyContent:"center",alignItems:"center"}}>
        <h1 style={{color:"#CD921E"}}>404 Page not found</h1>
    </div>
  )
}
